import { withRouterPath, InjectedProps as WithRouterPathHOC } from 'platform-components/hocs';
import React from 'react';
import { connect } from 'react-redux';

import * as themesSelectors from 'store/themes/selectors';
import { getIsTeacherFromMes } from 'utils/external-lms/external-lms';

import { ReduxTeacherStore } from '../../../typings';
import {
    LibraryBreadcrumb,
    LibraryBreadcrumbActual,
    LibraryBreadcrumbCalendarPlanShowcase,
} from '../../library.breadcrumb/breadcrumb';
import { LibraryBreadcrumbMes } from '../../library.breadcrumb/_mes/breadcrumb_mes';

interface HOCProps extends WithRouterPathHOC {}

type StoreProps = ReturnType<typeof mapStateToProps>;

interface Props extends StoreProps, HOCProps {
    showBackToCalendarPlan?: boolean;
}

export const SidebarBreadcrumbs = ({
    hasParentTheme,
    isActualTheme,
    parent,
    isTeacherFromMes,
    showBackToCalendarPlan,
}: Props) => {
    // Пользователь МЭШ не должен выходить за пределы рубрикатора
    if (isActualTheme && !isTeacherFromMes) {
        return <LibraryBreadcrumbActual />;
    }

    if (hasParentTheme) {
        return <LibraryBreadcrumb mix="sidebar__breadcrumb" parentTheme={parent} />;
    }

    if (isTeacherFromMes) {
        return <LibraryBreadcrumbMes mix="sidebar__breadcrumb" />;
    }

    if (showBackToCalendarPlan) {
        return <LibraryBreadcrumbCalendarPlanShowcase mix="sidebar__breadcrumb" />;
    }

    return null;
};

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: HOCProps) => {
    const {
        location: { search },
        match: {
            params: { subject, themeId: thId },
        },
    } = ownProps;

    const themeId = Number(thId);

    return {
        hasParentTheme: Boolean(themesSelectors.getThemeById(storeState, { subject, themeId, grade: null })?.parent),
        isActualTheme: themesSelectors.getIsActualTheme(storeState, { themeId }),
        parent: themesSelectors.getRootThemeByListTheme(storeState, { subject, themeId, grade: null }) || null,
        isTeacherFromMes: getIsTeacherFromMes(search),
    };
};

export default withRouterPath(connect(mapStateToProps)(SidebarBreadcrumbs));
